import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import BlockActionArticleItem from './BlockActionArticleItem';

const BlockActionArticle = (props) => {

    const { item, index, checkSeenPopup, show } = props;
    const { t } = useTranslation('block');

    var itemsToShow = []
    var popups = []
    if (item.length > 0) {
        popups = item;
    } else {
        popups = [item]
    }

    if (item.length > 0) {
        itemsToShow = item.filter(i => i.acPopupType != "2")
    }

    return (
        <>
            {popups.length > 0 ? (

                itemsToShow && itemsToShow.length > 0 ? (
                    <BlockActionArticleItem checkSeenPopup={checkSeenPopup} show={show} item={itemsToShow[0]} />
                ) : (
                    <BlockActionArticleItem checkSeenPopup={checkSeenPopup} show={show} item={popups[0]} />
                )
            ) : (
                index == undefined &&
                <div className="action-block action-block-no-content">
                    <div className="action-block-content action-block-content-no-content">
                        <img src={t('banerPlaceholder')} alt="Placeholder" title="Placeholder GIF video" ></img>
                    </div>
                </div>
            )
            }
        </>

    );
};

export default BlockActionArticle;